export enum AssociatedTypeActionTypes {
    API_RESPONSE_SUCCESS = '@@associatedType/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@associatedType/API_RESPONSE_ERROR',

    ADD_ASSOCIATED_LIST = '@@associatedType/ADD_ASSOCIATED_LIST',
    EDIT_ASSOCIATED_LIST = '@@associatedType/EDIT_ASSOCIATED_LIST',
    GET_ASSOCIATED_LIST = '@@associatedType/GET_ASSOCIATED_LIST',
    GET_ASSOCIATED_LISTS = '@@associatedType/GET_ASSOCIATED_LISTS',
    GET_ASSOCIATED_INST_LISTS = '@@associatedType/GET_ASSOCIATED_INST_LISTS',
    GET_REFER_DR_LISTS = '@@associatedType/GET_REFER_DR_LISTS',
    GET_USER_REFER_DR_LISTS = '@@associatedType/GET_USER_REFER_DR_LISTS',
    RESET = '@@associatedType/RESET',
    RESET_SUCCESS = '@@associatedType/RESET_SUCCESS',
    RESET_ERROR = '@@associatedType/RESET_ERROR',
}
